import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import { CircularProgress } from '@material-ui/core'
import loadingImage from 'assets/images/slider-skelton.png'
import { makeStyles } from '@material-ui/styles'
import { Typography } from "@material-ui/core"

import 'react-responsive-carousel/lib/styles/carousel.min.css'

export default function Banner(props) {
  const classes = useStyles()

  return (
    props.slides && props.slides.length>0?
      <div className={`${classes.sliderWrapper} ${props.className ? props.className : ''}`}>
        <Carousel
          autoPlay={true}
        >
          {props.slides.map((e, i) => (
            <div className={classes.sliderItem} key={i}>
              <img className={classes.sliderImage} src={e.image} />
              <Typography className={classes.sliderTitle} component="h1">
                {e.title}
              </Typography>
            </div>
          ))}
        </Carousel>
      </div>
    :
    <div className={classes.loadingWrapper}>
      <img className={classes.loadingImage} src={loadingImage} />
      <CircularProgress size={48} />
    </div>
  )
}

const useStyles = makeStyles(theme => ({
  loadingImage: {
    width: '100%',    
    position: 'absolute'
  },
  loadingWrapper: {
    width: '100%',
    height: '250px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
  },
  sliderImage: {
    width: '100%',
    objectFit: 'cover',
    [theme.breakpoints.only('xs')]: {
      height: '150px',
    }
  },
  sliderItem: {
    position: 'relative',
    overflow: 'hidden'
  },
  sliderWrapper: {
    width: '100%',
    '& .carousel .slider-wrapper': {
      borderRadius: 8
    },
    '& .carousel .slider': {
      [theme.breakpoints.only('xs')]: {
        height: '150px',
      }
    },
    '& .carousel .slide': {
      backgroundColor: 'transparent'
    },
    '& .carousel .thumbs-wrapper': {
      display: 'none'
    }
  },
  sliderTitle: {
    position: 'absolute',
    top: `calc(50% - 25px)`,
    left: `calc(10% - 25px)`,
    fontFamily: 'Poppins !important',
    fontSize: 30,
    fontWeight: 'bold',
    color: '#FFFFFF',
    width: '45%',
    textAlign: 'left',
    [theme.breakpoints.up('sm')]: {
      width: 400,
    },
    [theme.breakpoints.only('xs')]: {
      width: '100%',
      fontSize: 24,
      textAlign: 'center',
      left: 0,
    }
  },
}))
